import lightGallery from 'lightgallery';
import lgZoom from 'lightgallery/plugins/zoom';

class Lightbox {
  constructor() {
    this.initLightbox();
  }

  initLightbox() {
    const lightboxTrigger = document.querySelectorAll('[data-enable-lightbox]');

    lightboxTrigger.forEach((trigger) => {
      lightGallery(trigger, {
        plugins: [lgZoom],
        speed: 500,
        download: false,
        licenseKey: '1111-1111-111-1111',
      });
    });


    // imageTrigger.forEach((image) => {

    //   image.addEventListener("click", (evt) => {
    //     const modal = evt.target.dataset.modalId;
    //     const imageModal = document.getElementById(modal);
    //     openModal(imageModal)
    //   });
    // });
  }
}

export default Lightbox;

/*
const openModal = (modal) => {
  const modalImageWrapper = modal.querySelector('.modal__image-wrapper');
  const template = modal.querySelector('template');
  const templateImage = template.content.cloneNode(true)

  modalImageWrapper.appendChild(templateImage);
  modal.setAttribute('open', '');
  document.body.classList.add('hide-scrollbar');
  modal.classList.toggle('is-open');
}

const closeModal = (modal) => {
  const modalImageWrapper = modal.querySelector('.modal__image-wrapper');
  modalImageWrapper.innerHTML = '';
  modal.removeAttribute('open');
  document.body.classList.remove('hide-scrollbar');
  modal.classList.toggle('is-open');
}

const closeModalTrigger = document.querySelectorAll('.modal__close-button');
closeModalTrigger.forEach((close) => {
  close.addEventListener("click", (evt) => {
    console.log('close');
    const modal = evt.target.closest('.modal');
    closeModal(modal);
  } );
} );

// Close modal when Esc key is pressed
document.addEventListener("keyup", (evt) => {
  const openModal = document.querySelector('.modal[open]');
  if (evt.key == "Escape" && openModal) {
    closeModal(openModal);
  }
});
*/
